import * as types from 'actions/actionTypes';
import initialState from './initialState';
import $ from 'jquery';
import * as miscServices from 'services/miscServices';

/**
 * reducer per gestire le interrogazioni a crashboxx/services/icn
 * @param {*} state
 * @param {*} action
 */
export default function icnSearchReducer(state = initialState.icnSearch, action){

    switch(action.type)
    {
        case types.SEARCH_ICNLIST_CANCELREQUEST:
            return {...state, list: [], totalCount: 0, item: null, error: null, isSearching: false};

        case types.SEARCH_ICNLIST_REQUEST:
            return {...state, list: [], totalCount: 0, item: null, error: null, isSearching: true};
        case types.SEARCH_ICNLIST_SUCCESS:

            /*
                creo l'address
            */
            if(action.data.results)
            {
                $.each(action.data.results, function (index, item){
                    item.icn.address = miscServices.getAddressFromICN(item.icn);
                });
            }

            return {...state, list: action.data.results, totalCount: action.data.totalCount, error: null, isSearching: false};
        case types.SEARCH_ICNLIST_ERROR:
            return {...state, list: [], totalCount: 0, error: action.data, isSearching: false};

        case types.SEARCH_MAPICNLIST_REQUEST:
            return {...state, mapList: [], mapTotalCount: 0, error: null, isSearching: true};
        case types.SEARCH_MAPICNLISTWITHPARAMS_REQUEST:
            console.info("SEARCH_MAPICNLISTWITHPARAMS_REQUEST");
            return {...state, mapList: [], mapTotalCount: 0, error: null, isSearching: true};
        case types.SEARCH_MAPICNLIST_SUCCESS:
            /*
                creo l'address
            */
            if(action.data.results)
            {
                $.each(action.data.results, function (index, item){
                    item.icn.address = miscServices.getAddressFromICN(item.icn);
                });
            }

            return {...state, mapList: action.data.results, mapTotalCount: action.data.totalCount, error: null, isSearching: false};
        case types.SEARCH_MAPICNLIST_ERROR:
            return {...state, mapList: [], mapTotalCount: 0, error: action.data, isSearching: false};

        case types.GET_ICNITEM_REQUEST:
            return {...state, item: null, error: null, isSearching: true};
        case types.GET_ICNITEM_SUCCESS:
            /*
                in base alla configurazione dell'utente
            */
            if(action.data)
            {
                action.data.icn.address = miscServices.getAddressFromICN(action.data.icn);
            }

            return {...state, item: action.data.icn, error: null, isSearching: false};
        case types.GET_ICNITEM_ERROR:
            return {...state, error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/icnSearchReducer.js